import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.44 4.6a6.84 6.84 0 1 0 4.785 11.728l.005-.005A6.84 6.84 0 0 0 11.44 4.6Zm6.878 12.394a8.84 8.84 0 1 0-1.425 1.404l2.812 2.72a1 1 0 0 0 1.39-1.437l-2.777-2.687Z"
  />,
  'Search1'
)
